
// ContactForm.js
import React, { useState } from 'react';
import Input from '../Shared/Input';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here
        console.log('Form submitted:', formData);
        // Reset form
        setFormData({
            name: '',
            email: '',
            subject: '',
            message: ''
        });
    };

    return (
        <div className="row">
            <div className="col-md-6 mx-auto">
                <div className="card my-5">
                    <div className="card-body p-5">
                        <h2 className="text-center mb-4">Contact us for any query</h2>
                        <form onSubmit={handleSubmit} className="needs-validation">
                            <Input
                                label="Name"
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                            />
                            
                            <Input
                                label="Email"
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                            
                            <Input
                                label="Subject"
                                type="text"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                            />
                            
                            <Input
                                label="Message"
                                type="textarea"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                rows="5"
                            />

                            <button type="submit" className="btn btn-primary">Send Message</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;
